import {Destroyable} from "./destroyable.interface";

export function SelfDestruct<Type>(component: Destroyable) {
  component.destroyed$.next(component);
  component.destroyed$.complete();
}
